import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  dialogTitle: {
    height: 55,
    display: "flex",
    alignItems: "center",
    padding: "0 20px",
    fontSize: 20,
    "& .MuiTypography-h6": {
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    }
  }
});
